import React from 'react';
import ProjectCarousel from './carausal';

const ServicesSection = () => {
    const teamMembers = [
        {
            name: "Henry George",
            role: "Safety Officer",
            desc: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects",
            // img: "/assets/bannerhome/01.webp",
        },
        {
            name: "Thomas Bryant",
            role: "Civil Engineer",
            desc: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects",
            // img: "/assets/bannerhome/02.webp",
        },
        {
            name: "Benjamin Clarke",
            role: "Project Coordinator",
            desc: "Highly skilled and experienced construction expert, known for his deep expertise in managing large-scale construction projects",
            // img: "/assets/bannerhome/03.webp",
        },
    ];

    const services = [
        {
            title: "Building and Construction",
            description:
                "We supply construction materials for all phases, collaborating with architects, designers, key stakeholders as well as local distributors",
            image: "/assets/bannerhome/04.svg",
        },
        {
            title: "Interior Finishing",
            description:
                "The process of construction involves a diverse range of activities, combining skilled labor, advanced technology, and precise planning to bring projects to life.",
            image: "/assets/bannerhome/05.svg",
        },
        {
            title: "Project Management",
            description:
                "The process of construction involves a diverse range of activities, combining skilled labor, advanced technology, and precise planning to bring projects to life.",
            image: "/assets/bannerhome/06.svg",
        },
    ];

    return (
        <section className="py-4 px-4 md:px-2 lg:px-4 bg-[#000] overflow-x-hidden">
            <div className="max-w-6xl mx-auto">
                {/* Services */}
                <div className="text-center text-[#00A3A1] mb-3">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">WHAT WE OFFER</h2>
                    <p className="text-xl">Explore Our Services</p>
                </div>

                <div className="flex flex-wrap justify-center gap-6 w-full">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="flex-1 my-2 text-white min-w-[250px] max-w-sm bg-[#063970] rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                            style={{ outline: "2px solid #BCA033" }}
                        >
                            <div className="p-4">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="p-3 mb-2 rounded-md w-full h-20 object-contain"
                                    style={{ outline: "2px solid #BCA033" }}
                                />
                                <h3 className="text-xl font-semibold mb-1">{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Carousel */}
            <ProjectCarousel />

            {/* Team Section */}
            {/* <div className="text-center my-8 px-4">
                <h2 className="text-[#00A3A1] text-lg md:text-xl font-semibold">
                    Expert Team Members
                </h2>
                <h1 className="text-white text-2xl md:text-4xl font-bold mt-2">
                    Meet The Awesome Team
                </h1>
            </div>

            <div className="flex flex-wrap gap-6 justify-center w-full">
                {teamMembers.map((member, index) => (
                    <div
                        key={index}
                        className="flex flex-col md:flex-row bg-[#063970] text-white rounded-lg p-6 border border-yellow-400 w-full md:w-[48%] lg:w-[30%]"
                    >
                        <div className="flex-1">
                            <h3 className="text-xl font-bold">{member.name}</h3>
                            <p className="text-sm text-gray-200">{member.role}</p>
                            <p className="mt-2 text-gray-300 text-sm">{member.desc}</p>
                        </div>

                   
                    </div>
                ))}
            </div> */}

            <div className="text-center my-2 px-6">
                <h2 className="text-[#00A3A1] text-lg md:text-xl font-semibold">
                    Strong & Dedicated Team
                </h2>
                <h1 className="text-white text-2xl md:text-4xl font-bold mt-1">
                    Building Excellence Together
                </h1>
                <p className="text-gray-300 max-w-4xl mx-auto mt-2 text-sm md:text-base">
                    We have a strong team of skilled engineers, architects, and construction
                    professionals who are committed to delivering high-quality projects on time.
                    With years of experience and innovative thinking, our team ensures
                    excellence in every detail.
                </p>

                <div className="mt-3">
                    <a
                        href="/our-team"
                        className="inline-block text-[#fff] bg-[#063970] font-semibold px-6 py-3 rounded-lg shadow-md hover:bg-yellow-500 transition"
                    >
                        Meet Our Team
                    </a>
                </div>
            </div>

        </section>
    );
};

export default ServicesSection;
